import Handsontable from "handsontable";
import Choices from "choices.js";

class StaffAssignmentCellEditor extends Handsontable.editors.TextEditor {
    init() {
        super.init();
    }

    prepare(row, col, prop, td, originalValue, cellProperties) {
        if (originalValue == undefined) { originalValue = ""; }
        super.prepare(row, col, prop, td, originalValue, cellProperties);
        this.toShow = 5;
        this.showDir = 'bottom';
        this.calcu(row, cellProperties);
        this.textareaParentStyle.width = (td.clientWidth > 200 ? td.clientWidth - 1 : 200) + 'px';
        this.options = {};
        if (this.cellProperties && this.cellProperties.selectOptions) {
            this.options = Object.assign(this.options, cellProperties.selectOptions);
        }
        cellProperties.selectOptions = Object.assign(
            {},
            cellProperties.selectOptions
        );
    }

    createElements() {
        this.TEXTAREA = document.createElement("SELECT");

        // Handsontable copy paste plugin calls this.TEXTAREA.select()
        this.TEXTAREA.select = function () { };
        Handsontable.dom.addClass(this.TEXTAREA, "handsontableInput");
        this.textareaStyle = this.TEXTAREA.style;
        this.textareaStyle.width = 0;
        this.textareaStyle.height = 0;
        this.TEXTAREA_PARENT = document.createElement("DIV");
        Handsontable.dom.addClass(this.TEXTAREA_PARENT, "handsontableInputHolder");
        this.textareaParentStyle = this.TEXTAREA_PARENT.style;
        this.textareaParentStyle.top = 0;
        this.textareaParentStyle.left = 0;
        this.textareaParentStyle.display = "none";
        this.TEXTAREA_PARENT.appendChild(this.TEXTAREA);
        this.instance.rootElement.appendChild(this.TEXTAREA_PARENT);
    }

    calcu(row, cellProperties) {
        var totalRows = cellProperties.instance.countRows();
        if (totalRows > 7) {
            var mid = (totalRows + 1) / 2;
            if (row >= mid) {
                this.showDir = 'top';
                this.toShow = Math.max(Math.ceil((totalRows + 1) / 3), Math.ceil((row + 1) / 2));
            }
            else {
                this.toShow = 5;
                this.showDir = 'bottom';
            }
        }

    }

    getValue() {
        //TODO
        var result = [];
        var options = this.TEXTAREA && this.TEXTAREA.options;
        var opt;
        for (var i = 0, iLen = options.length; i < iLen; i++) {
            opt = options[i];
            if (opt.selected) {
                result.push(opt.value || opt.text);
            }
        }
        return result.join("|");
    }
    setValue(value) {
        //TODO
        let self = this;
        let array =
            typeof value == "string"
                ? value.split("|").filter(ov => ov !== "").map(m => (typeof m == "string" ? m.trim() : m))
                : value;
        for (var i = 0; i < self.TEXTAREA.length; i++) {
            self.TEXTAREA.options[i].selected = false;
            array.forEach(function (arrayItem) {
                if (self.TEXTAREA.options[i].value === arrayItem) {
                    self.TEXTAREA.options[i].selected = true;
                }
            });
        }
    }
    open() {
        this.refreshDimensions();
        this.textareaParentStyle.display = "block";
        //display the list
        this.TEXTAREA.style.display = "none";
        var options = Object.assign({}, this.cellProperties.selectOptions, {
            width: "100%"
        });

        if (options.multiple) {
            this.TEXTAREA.setAttribute("multiple", true);
        } else {
            this.TEXTAREA.removeAttribute("multiple");
        }

        let opt = document.createElement("option");
        opt.setAttribute("value", "");
        this.TEXTAREA.appendChild(opt);

        while (this.TEXTAREA.firstChild) {
            this.TEXTAREA.removeChild(this.TEXTAREA.firstChild);
        }
        let el = null;
        let originalValue =
            this.originalValue && typeof this.originalValue == "string"
                ? this.originalValue
                    .split("|").filter(ov => ov !== "")
                    .map(i => (typeof i == "string" ? i.trim() : i))
                : this.originalValue;

        if (options.data && options.data.length) {
            if (options.multiple) {
                for (let i = 0; i < originalValue.length; i++) {
                    el = document.createElement("option");
                    el.setAttribute("value", originalValue[i]);
                    el.innerHTML = originalValue[i];
                    el.setAttribute("selected", true);
                    this.TEXTAREA.appendChild(el);
                }
            }

            if (this.prop === "default_myview_name") {
                let myView = this.instance.getDataAtCell(this.row, 11).split("|").filter(mv => mv !== "");

                el = document.createElement("option");
                el.setAttribute("value", "");
                el.setAttribute("disabled", "disabled");
                el.setAttribute("selected", true);
                el.innerHTML = "";
                this.TEXTAREA.appendChild(el);
                for (let i = 0; i < myView.length; i++) {

                    el = document.createElement("option");
                    el.setAttribute("value", myView[i]);
                    el.innerHTML = myView[i];
                    if (originalValue && originalValue.indexOf(myView[i]) > -1) {
                        el.setAttribute("selected", true);
                    }
                    this.TEXTAREA.appendChild(el);
                }

            } else {

                if (!options.multiple) {
                    el = document.createElement("option");
                    el.setAttribute("value", "");
                    el.setAttribute("disabled", "disabled");
                    el.setAttribute("selected", true);
                    el.innerHTML = "";
                    this.TEXTAREA.appendChild(el);
                }

                for (let i = 0; i < options.data.length; i++) {
                    // added to remove empty get selected
                    el = document.createElement("option");
                    el.setAttribute("value", options.data[i].label);
                    el.innerHTML = options.data[i].label;
                    if (originalValue.indexOf(options.data[i].label) > -1) {
                        if (options.multiple) {
                            el.setAttribute("selected", true);
                            continue;
                        } else {
                            el.setAttribute("selected", true);
                        }
                    }
                    this.TEXTAREA.appendChild(el);
                }
            }
        }

        this.choices = new Choices(this.TEXTAREA, {
            silent: true,
            searchEnabled: true,
            searchChoices: true,
            removeItems: true,
            removeItemButton: (this.prop === "account_disabled") ? false : true,
            shouldSort: false,
            shouldSortItems: false,
            resetScrollPosition: true,
            renderSelectedChoices: "auto",
            placeholder: true,
            placeholderValue: "Search...",
            searchPlaceholderValue: "Search...",
            searchResultLimit: 100,
            renderChoiceLimit: this.toShow,
            position: this.showDir,
            fuseOptions: {
                location: 0,
                distance: 800,
                threshold: 0.2,
                findAllMatches: false

            },
            choices: []
        });
        this.choices.showDropdown();
    }
    close() {
        //TODO
        this._opened = false;
        this.TEXTAREA.style.display = "none";
        if (this.choices !== undefined) {
            this.choices.destroy();
        }
    }
    focus() {
        //TODO
        this.TEXTAREA.focus();
        if (this.choices !== undefined) {
            this.choices.showDropdown();
        }
    }
    onBeforeKeyDown() {
        //TODO
        this.TEXTAREA.style.display = "block";
    }
}

export default StaffAssignmentCellEditor;
